import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { ExperienceOverviewService } from '../../experience-overview.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'experience-overview-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './overview-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./overview-view.part.scss'],
})
export class ExperienceOverviewViewPart {

	private readonly util = inject(UtilityService);
	private readonly pageService = inject(ExperienceOverviewService);

	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});
}